export default __webpack_public_path__ + "static/media/whatsAppRealcase-en.2e5bce2d.png";